// import { NavLink, Link } from 'react-router-dom';
// import { NavLink } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import pro_img from '../images/pro_img.png';
// import download from '../images/download.svg';
// import view from '../images/view.svg';
import Fade from 'react-reveal/Fade';       
import { Zoom } from 'react-reveal';

const Info = () => {

    return (
        <div className='container'>
            <Row className='justify-content-between p-2 mt-lg-3'>
                <Col md={4} className='text-center p-2'>
                    {/* IMAGE */}
                    <Col className='p-1 '>
                        <Zoom delay={750}>
                            <img 
                                src={pro_img}  
                                alt='Pia'
                                className='img-fluid ' 
                                style={{  borderRadius: '50%', border: '5px solid var(--trim-primary-color)' }}
                            />
                        </Zoom>
                    </Col>
                    {/* removed access to resume */}
                    {/* <Col className='my-2'>
                    
                        <div className='mx-1 my-0'>
                            <Fade bottom delay={800}>
                                <p className='text my-1'>Resume/CV: </p>
                            </Fade>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <div className='mx-1'>
                                <Fade bottom delay={800}>
                                    <Link className='btn btn-outline-primary p-1 resBtn' to='/resume'>
                                        <img src={view} alt='view resume' className='resImg'/>
                                    </Link>
                                </Fade>
                            </div >
                            <div className='mx-1'>
                                <Fade bottom delay={800}>
                                    <button className='btn btn-outline-primary p-1 resBtn'>
                                        <a href='resume.pdf' download='resume.pdf' alt='download-resume'>
                                            <img src={download} alt='download-resume' className='resImg'/>
                                        </a>
                                    </button>
                                </Fade>
                            </div>
                        </div>
                    </Col> */}
                </Col>

                {/* ABOUT  */}
                <Col md={8} className='mt-md-0 px-0 p-md-2'>
                    <div className='m-2' >
                        <Fade bottom delay={800}>
                            <h2 className='about-intro'>A curious software engineer who loves solving problems.</h2>
                        </Fade>
                        <Fade bottom delay={800}>
                            <p className='mb-2 text'>
                                I'm a Software Engineer who enjoys solving complex problems by building thoughtful, reliable software. I believe great technology should be intuitive, accessible, and designed with the people using it in mind. Whether I'm developing user interfaces, designing backend systems, or contributing to AI-powered products, I enjoy creating software that has a meaningful impact.
                            </p>
                        </Fade>
                        <Fade bottom delay={800}>
                            <p className='mb-2 text'>
                                My path into software engineering has been driven by curiosity and a desire to understand how things work. After discovering a passion for building software, I committed myself to continuously learning and developing the skills needed to create modern applications. That journey has led me to opportunities where I can contribute across the full stack while working on products that solve real-world problems.
                            </p>
                        </Fade>
                        <Fade bottom delay={800}>
                            <p className='mb-2 text'>
                                Today, I work as a Software Engineer at
                                <a href='https://www.pointhealth.ai' target='blank' className='special-text touch-link ph-link text-decoration-none'><strong> PointHealth AI</strong></a>, where I help build AI-powered healthcare applications that support clinicians and patients. Working in healthcare has reinforced the importance of writing reliable, maintainable software and collaborating closely with designers, product teams, and domain experts to deliver meaningful solutions.
                            </p>
                        </Fade>
                        <Fade bottom delay={800}>
                            <p className='mb-2 text'>
                                I enjoy tackling challenging problems, learning from talented teammates, and continuously improving both my technical and professional skills. I'm always looking for opportunities to build products that make a positive impact and to grow as an engineer along the way.
                            </p>
                        </Fade>
                        {/* <Fade bottom delay={800}>
                            <p className='mb-2 text'>
                                If you'd like to connect, collaborate, or simply say hello, I'd love to hear from you.
                            </p>
                        </Fade> */}
                        {/* <Fade bottom delay={800}>
                            <NavLink tag='link' className='nav-link touch-link mx-0 p-0'  to='/contact'> 
                                <u><em><h3>Get in Touch!</h3></em></u>
                            </NavLink>
                        </Fade> */}
                    </div>
                </Col>
            </Row>
            <hr  className='mx-auto my-4 text-primary col-8'/>
        </div>
    )
}

export default Info;